import React, { useState, useContext, useEffect } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  useMediaQuery,
  Box,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  ShoppingBag as ShoppingBagIcon,
  PendingActions as PendingActionsIcon,
} from "@mui/icons-material";
import StoreIcon from "@mui/icons-material/Store";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LayersIcon from "@mui/icons-material/Layers";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BarChartIcon from "@mui/icons-material/BarChart";
import CancelIcon from "@mui/icons-material/Cancel";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import UndoIcon from "@mui/icons-material/Undo";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import PendingIcon from "@mui/icons-material/Pending";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DashboardIcon from "@mui/icons-material/Dashboard";
import topLogo from "../images/headerimg.png";
import { NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import "../../Component/common-css.css";

const Sidebar = ({ open, toggleSidebar }) => {
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const [openCollapse, setOpenCollapse] = useState(null);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const drawerWidth = 250;

  const handleMenuClick = () => {
    if (isMobile) toggleSidebar(false);
  };

  const isActiveRoute = (paths) => paths.includes(location.pathname);

  // Auto open the correct collapse based on route
  useEffect(() => {
    const path = location.pathname;

    if (
      [
        "/invoice",
        "/vendor-name",
        "/vendorBatchPage",
        "/sendBackByapproval",
        "/sendBackdetailPage",
        "/ReviewBatchPage"
      ].includes(path)
    ) {
      setOpenCollapse("batches");
    } else if (
      [
        "/approval",
        "/approvalBatchPage",
        "/partialApproval",
        "/partialDetailPage",
        "/ApprovedBatches",
        "/ApprovedBatchData",
      ].includes(path)
    ) {
      setOpenCollapse("approval");
    } else if (
      [
        "/rejected-cases",
        "/reajectedcasesPage",
        "/query-case",
        "/queryCasesPage",
        "/hold-case",
        "/holdCasesPage",
        "/networkRejectedCases",
      ].includes(path)
    ) {
      setOpenCollapse("cases");
    } else if (
      [
        "/pendingPaymentMIS",
        "/paidPaymentMIS",
        "/UTRpaymentMIS",
        "/rawdataMIS",
        "/OpenCases",
      ].includes(path)
    ) {
      setOpenCollapse("mis");
    } else {
      setOpenCollapse(null);
    }
  }, [location.pathname]);

  const isFinance = user?.role === "finance" || user?.role === "Finance";
  const isVendorOnDashboard = location.pathname === "/Dashboard" && user?.role === "ServiceProvider";
  if (isFinance || isVendorOnDashboard) return null;

  const toggleCollapse = (menuName) => {
    setOpenCollapse(openCollapse === menuName ? null : menuName);
  };

  const activeItemStyle = {
    backgroundColor: "#8000d7",
    color: "white",
    "& .MuiListItemText-root, & .MuiTypography-root": { color: "white" },
    "& .MuiListItemIcon-root": { color: "white" },
  };

  const menuItemStyles = {
    "&.active, &.Mui-selected": activeItemStyle,
    color: "inherit",
  };

  return (
    <Drawer
      className="header_and_sidebar_only_for_index"
      variant={isMobile ? "temporary" : "persistent"}
      open={open}
      sx={{
        width: open ? drawerWidth : 0,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          position: "fixed",
          left: 0,
          top: "0px",
          height: "100vh",
          transition: "width 0.3s ease-in-out",
        },
      }}
    >
      <Box sx={{ textAlign: "center", padding: "20px" }} className="sidebar_list_item">
        <img src={topLogo} alt="Logo" style={{ width: "150px", height: "auto" }} />
      </Box>
      <List>
        {(user?.role === "NetworkAdmin" || user?.role === "NetworkSubAdmin" || user?.role === "ServiceProvider") && (
          <>
            <ListItem
              component={NavLink}
              to="/Dashboard"
              onClick={handleMenuClick}
              sx={isActiveRoute(["/Dashboard"]) ? activeItemStyle : {}}
              style={{ color: "rgba(0, 0, 0, 0.87)" }}
            >
              <ListItemIcon><DashboardIcon /></ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItem>
            <ListItem
              component={NavLink}
              to="/invoice"
              onClick={handleMenuClick}
              sx={isActiveRoute(["/invoice"]) ? activeItemStyle : {}}
              style={{ color: "rgba(0, 0, 0, 0.87)" }}
            >
              <ListItemIcon><ShoppingBagIcon /></ListItemIcon>
              <ListItemText primary="Invoice" />
            </ListItem>
            {/* Batches Menu */}
            {/* <ListItem button onClick={() => toggleCollapse("batches")}>
              <ListItemIcon><ShoppingBagIcon sx={{ color: "inherit" }} /></ListItemIcon>
              <ListItemText primary="Invoices" />
              {openCollapse === "batches" ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openCollapse === "batches"} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  component={NavLink}
                  to="/invoice"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/invoice", "/vendor-name", "/vendorBatchPage", "/ReviewBatchPage"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><ShoppingBagIcon /></ListItemIcon>
                  <ListItemText primary="Create Invoice" />
                </ListItem>
                <ListItem
                  component={NavLink}
                  to="/sendBackByapproval"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/sendBackByapproval", "/sendBackdetailPage"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><UndoIcon /></ListItemIcon>
                  <ListItemText primary="Back From Approval" />
                </ListItem>
              </List>
            </Collapse> */}

            {/* Approval Menu */}
            <ListItem button onClick={() => toggleCollapse("approval")}>
              <ListItemIcon><PendingActionsIcon sx={{ color: "inherit" }} /></ListItemIcon>
              <ListItemText primary="Approval" />
              {openCollapse === "approval" ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openCollapse === "approval"} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  component={NavLink}
                  to="/approval"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/approval", "/approvalBatchPage"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><PendingIcon /></ListItemIcon>
                  <ListItemText primary="Pending Approval" />
                </ListItem>
                {/* <ListItem
                  component={NavLink}
                  to="/partialApproval"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/partialApproval", "/partialDetailPage"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><HourglassBottomIcon /></ListItemIcon>
                  <ListItemText primary="Partial Approval" />
                </ListItem> */}
                <ListItem
                  component={NavLink}
                  to="/ApprovedBatches"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/ApprovedBatches", "/ApprovedBatchData"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><CheckCircleIcon /></ListItemIcon>
                  <ListItemText primary="Approved Batches" />
                </ListItem>
              </List>
            </Collapse>

            {/* Cases Menu */}
            {/* <ListItem button onClick={() => toggleCollapse("cases")}>
              <ListItemIcon><ReportProblemIcon sx={{ color: "inherit" }} /></ListItemIcon>
              <ListItemText primary="Cases" />
              {openCollapse === "cases" ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openCollapse === "cases"} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  component={NavLink}
                  to="/rejected-cases"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/rejected-cases", "/reajectedcasesPage"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><CancelIcon /></ListItemIcon>
                  <ListItemText primary="Rejected Cases" />
                </ListItem>
                <ListItem
                  component={NavLink}
                  to="/query-case"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/query-case", "/queryCasesPage"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><HelpOutlineIcon /></ListItemIcon>
                  <ListItemText primary="Query Cases" />
                </ListItem>
                <ListItem
                  component={NavLink}
                  to="/hold-case"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/hold-case", "/holdCasesPage"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><PauseCircleOutlineIcon /></ListItemIcon>
                  <ListItemText primary="Hold Cases" />
                </ListItem>
              </List>
            </Collapse> */}
            {/* <ListItem
              component={NavLink}
              to="/networkRejectedCases"
              onClick={handleMenuClick}
              sx={isActiveRoute(["/networkRejectedCases"]) ? activeItemStyle : {}}
              style={{ color: "rgba(0, 0, 0, 0.87)" }}
            >
              <ListItemIcon><HighlightOffIcon /></ListItemIcon>
              <ListItemText primary="Network Rejected" />
            </ListItem> */}
            {/* Concerns */}
            {/* <ListItem
              component={NavLink}
              to="/concern"
              onClick={handleMenuClick}
              sx={isActiveRoute(["/concern"]) ? activeItemStyle : {}}
              style={{ color: "rgba(0, 0, 0, 0.87)" }}
            >
              <ListItemIcon><ReportProblemOutlinedIcon /></ListItemIcon>
              <ListItemText primary="Concerns" />
            </ListItem> */}

            {/* MIS Menu */}
            {/* <ListItem button onClick={() => toggleCollapse("mis")}>
              <ListItemIcon><BarChartIcon sx={{ color: "inherit" }} /></ListItemIcon>
              <ListItemText primary="MIS" />
              {openCollapse === "mis" ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openCollapse === "mis"} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  component={NavLink}
                  to="/pendingPaymentMIS"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/pendingPaymentMIS"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><StoreIcon /></ListItemIcon>
                  <ListItemText primary="Unpaid MIS" />
                </ListItem>
                <ListItem
                  component={NavLink}
                  to="/paidPaymentMIS"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/paidPaymentMIS"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><ReceiptIcon /></ListItemIcon>
                  <ListItemText primary="Paid Payment MIS" />
                </ListItem>
                <ListItem
                  component={NavLink}
                  to="/rawdataMIS"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/rawdataMIS"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><AccountBalanceWalletIcon /></ListItemIcon>
                  <ListItemText primary="Raw Data MIS" />
                </ListItem>
                <ListItem
                  component={NavLink}
                  to="/UnbilledCases"
                  onClick={handleMenuClick}
                  sx={
                    isActiveRoute(["/UnbilledCases"])
                      ? { pl: 4, ...activeItemStyle }
                      : { pl: 4, ...menuItemStyles }
                  }
                >
                  <ListItemIcon><WorkOutlineIcon /></ListItemIcon>
                  <ListItemText primary="Unbilled Cases" />
                </ListItem>
              </List>
            </Collapse> */}
          </>
        )}
        {user?.role === "Finance" && (
          <ListItem
            component={NavLink}
            to="/ApprovedBatches"
            onClick={handleMenuClick}
            sx={
              isActiveRoute(["/ApprovedBatches", "/ApprovedBatchData"])
                ? activeItemStyle
                : {}
            }
            style={{ color: "rgba(0, 0, 0, 0.87)" }}
          >
            <ListItemIcon><CheckCircleIcon /></ListItemIcon>
            <ListItemText primary="Approved Batches" />
          </ListItem>
        )}
      </List>
    </Drawer>
  );
};

export default Sidebar;
